interface Props {
  color?: string;
}
const ShowAllMachineIcon: React.FC<Props> = (props) => {
  const { color = "#000" } = props;
  return (
    <svg
      id="icon-outlined-application-border"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="24"
      height="24"
      viewBox="0 0 24 20"
    >
      <defs>
        <clipPath id="clipPath">
          <rect
            id="icon_outlined_application_border_clip_mask_"
            data-name="icon/outlined/application/border (clip mask)"
            width="24"
            height="24"
            fill="none"
          />
        </clipPath>
      </defs>
      <rect
        id="icon_outlined_application_border_clip_mask_2"
        data-name="icon/outlined/application/border (clip mask)"
        width="24"
        height="24"
        fill="none"
      />
      <g id="icon_outlined_application_border" data-name="icon/outlined/application/border" clipPath="url(#clipPath)">
        <g id="icon_outlined_application_border_clip_group_" data-name="icon/outlined/application/border (clip group)">
          <rect
            id="icon_outlined_application_border_style_"
            data-name="icon/outlined/application/border (style)"
            width="24"
            height="24"
            fill="none"
          />
          <path
            id="Vector"
            d="M4.2,4.375H.175A.175.175,0,0,1,0,4.2V.175A.175.175,0,0,1,.175,0H4.2a.175.175,0,0,1,.175.175V4.2A.175.175,0,0,1,4.2,4.375ZM.394.394V3.981H3.981V.394Z"
            transform="translate(2.813 2.812)"
            stroke={color}
            strokeWidth="1"
          />
          <path
            id="Vector-2"
            data-name="Vector"
            d="M4.2,4.375H.175A.175.175,0,0,1,0,4.2V.175A.175.175,0,0,1,.175,0H4.2a.175.175,0,0,1,.175.175V4.2A.175.175,0,0,1,4.2,4.375ZM.394.394V3.981H3.981V.394Z"
            transform="translate(2.813 9.812)"
            stroke={color}
            strokeWidth="1"
          />
          <path
            id="Vector-3"
            data-name="Vector"
            d="M4.2,4.375H.175A.175.175,0,0,1,0,4.2V.175A.175.175,0,0,1,.175,0H4.2a.175.175,0,0,1,.175.175V4.2A.175.175,0,0,1,4.2,4.375ZM.394.394V3.981H3.981V.394Z"
            transform="translate(2.813 16.812)"
            stroke={color}
            strokeWidth="1"
          />
          <path
            id="Vector-4"
            data-name="Vector"
            d="M4.2,4.375H.175A.175.175,0,0,1,0,4.2V.175A.175.175,0,0,1,.175,0H4.2a.175.175,0,0,1,.175.175V4.2A.175.175,0,0,1,4.2,4.375ZM.394.394V3.981H3.981V.394Z"
            transform="translate(9.813 2.812)"
            stroke={color}
            strokeWidth="1"
          />
          <path
            id="Vector-5"
            data-name="Vector"
            d="M4.2,4.375H.175A.175.175,0,0,1,0,4.2V.175A.175.175,0,0,1,.175,0H4.2a.175.175,0,0,1,.175.175V4.2A.175.175,0,0,1,4.2,4.375ZM.394.394V3.981H3.981V.394Z"
            transform="translate(9.813 9.812)"
            stroke={color}
            strokeWidth="1"
          />
          <path
            id="Vector-6"
            data-name="Vector"
            d="M4.2,4.375H.175A.175.175,0,0,1,0,4.2V.175A.175.175,0,0,1,.175,0H4.2a.175.175,0,0,1,.175.175V4.2A.175.175,0,0,1,4.2,4.375ZM.394.394V3.981H3.981V.394Z"
            transform="translate(9.813 16.812)"
            stroke={color}
            strokeWidth="1"
          />
          <path
            id="Vector-7"
            data-name="Vector"
            d="M4.2,4.375H.175A.175.175,0,0,1,0,4.2V.175A.175.175,0,0,1,.175,0H4.2a.175.175,0,0,1,.175.175V4.2A.175.175,0,0,1,4.2,4.375ZM.394.394V3.981H3.981V.394Z"
            transform="translate(16.813 2.812)"
            stroke={color}
            strokeWidth="1"
          />
          <path
            id="Vector-8"
            data-name="Vector"
            d="M4.2,4.375H.175A.175.175,0,0,1,0,4.2V.175A.175.175,0,0,1,.175,0H4.2a.175.175,0,0,1,.175.175V4.2A.175.175,0,0,1,4.2,4.375ZM.394.394V3.981H3.981V.394Z"
            transform="translate(16.813 9.812)"
            stroke={color}
            strokeWidth="1"
          />
        </g>
      </g>
    </svg>
  );
};

export default ShowAllMachineIcon;
